// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".max-w-718[data-v-9393a6c0] {\n  max-width: 718px;\n}\n.header[data-v-9393a6c0] {\n  display: flex;\n  justify-content: space-between;\n}\n", ""]);
// Exports
module.exports = exports;
